import { MgrRestriction } from "@/models/MgrRestriction/MgrRestriction";
import { MgrRestrictionDef } from '@/models/MgrRestriction/MgrRestrictionDef';
import { FunctionBit } from "../ScvLicenseManager";
import { useUserSettingStore } from "../Store/UserSettingStore";

// 
// 機能制限IDと必要なライセンスを定義します。
// 
export class RestrictionRequireLicense {
    private static defRestriction = new MgrRestrictionDef();

    // 機能制限IDと必要なライセンスのマップ(ライセンス配列は OR 判定され、いずれか１つでも有効なら機能制限も有効)
    private static licenseMap = new Map<number, number[]>()

        // 資産管理
        .set(this.defRestriction.AstAPInf               , [FunctionBit.FunctionAst_OfficeSetup,FunctionBit.FunctionAst_VirusChecker,FunctionBit.FunctionAst_AppSetup,FunctionBit.FunctionAst_AppSetup,FunctionBit.FunctionAst_OSLicense,FunctionBit.FunctionAst_WinPatch,FunctionBit.FunctionPat_Software,FunctionBit.FunctionPat_Software])
        .set(this.defRestriction.AstAPInf_OfficeSetup   , [FunctionBit.FunctionAst_OfficeSetup])    // アプリケーション一覧 Office
        .set(this.defRestriction.AstAPInf_VirusChecker  , [FunctionBit.FunctionAst_VirusChecker])   // アプリケーション一覧 ウイルス対策ソフト
        .set(this.defRestriction.AstAPInf_AppSetup      , [FunctionBit.FunctionAst_AppSetup])       // アプリケーション一覧 アプリケーション
        .set(this.defRestriction.AstAPInf_WinStoreApp   , [FunctionBit.FunctionAst_AppSetup])       // アプリケーション一覧 Windowsストアアプリ
        .set(this.defRestriction.AstAPInf_OSLicense     , [FunctionBit.FunctionAst_OSLicense])      // アプリケーション一覧 OS
        .set(this.defRestriction.AstAPInf_WinPatch      , [FunctionBit.FunctionAst_WinPatch])       // アプリケーション一覧 Windows更新
        .set(this.defRestriction.AstAPInf_Software      , [FunctionBit.FunctionPat_Software])       // アプリケーション一覧 ソフトウェア配布
        .set(this.defRestriction.AstAPInf_Software_Edit , [FunctionBit.FunctionPat_Software])       // アプリケーション一覧 ソフトウェア配布 編集（ソフトウェア 追加/編集/削除）
        .set(this.defRestriction.USBDevSet_Media_Manage_List_DeviceAlertSet, [FunctionBit.FunctionAlt_Log])     // デバイス管理 デバイス種別制御設定／アラート設定
        .set(this.defRestriction.PcConditionCheck       , [FunctionBit.FunctionOth_PCConditionCheck])     // PC環境診断

        // ログ管理
        .set(this.defRestriction.LGB                    , [FunctionBit.FunctionLog_AgLogonoff,      // ログ閲覧
                                                           FunctionBit.FunctionLog_Application,
                                                           FunctionBit.FunctionLog_FileOperation,
                                                           FunctionBit.FunctionLog_System,
                                                           FunctionBit.FunctionLog_Printer,
                                                           FunctionBit.FunctionLog_SendMail,
                                                           FunctionBit.FunctionLog_WebDownload,
                                                           FunctionBit.FunctionLog_Removable,
                                                           FunctionBit.FunctionLog_AgOperation,
                                                           FunctionBit.FunctionLog_SendMail,
                                                           FunctionBit.FunctionExt_LimitOptionAssets
                                                        ])                                        // ログ閲覧  (資産管理限定版でもログイン履歴のシステムログは必要なのであえて未定義)
        .set(this.defRestriction.LGB_AgLogonoff         , [FunctionBit.FunctionLog_AgLogonoff])     // ログ閲覧 起動・終了
        .set(this.defRestriction.LGB_Application        , [FunctionBit.FunctionLog_Application])    // ログ閲覧 アプリケーション
        .set(this.defRestriction.LGB_FileOperation      , [FunctionBit.FunctionLog_FileOperation])  // ログ閲覧 ファイル操作
        .set(this.defRestriction.LGB_System             , [FunctionBit.FunctionLog_System, FunctionBit.FunctionExt_LimitOptionAssets])         // ログ閲覧 システム)
        .set(this.defRestriction.LGB_Printer            , [FunctionBit.FunctionLog_Printer])        // ログ閲覧 プリント
        .set(this.defRestriction.LGB_WebDownload        , [FunctionBit.FunctionLog_WebDownload])    // ログ閲覧 Webアクセス
        .set(this.defRestriction.LGB_Removable          , [FunctionBit.FunctionLog_Removable])      // ログ閲覧 ドライブ
        .set(this.defRestriction.LGB_ActWnd             , [FunctionBit.FunctionLog_AgOperation])    // ログ閲覧 クライアント操作ログ
        .set(this.defRestriction.LGB_SendMail           , [FunctionBit.FunctionLog_SendMail])       // ログ閲覧 送信メールログ
        .set(this.defRestriction.LGB_NetDevice          , [FunctionBit.FunctionLog_AgLogonoff,      // ログ閲覧 通信デバイスログは単独定義はなく、いずれかのログライセンスで有効
                                                           FunctionBit.FunctionLog_Application,
                                                           FunctionBit.FunctionLog_FileOperation,
                                                           FunctionBit.FunctionLog_System,       // 資産管理限定OPでもシステムログは必須なので意図的
                                                           FunctionBit.FunctionLog_Printer,
                                                           FunctionBit.FunctionLog_SendMail,
                                                           FunctionBit.FunctionLog_WebDownload,
                                                           FunctionBit.FunctionLog_Removable,
                                                           FunctionBit.FunctionLog_AgOperation,
                                                           FunctionBit.FunctionLog_SendMail])
        .set(this.defRestriction.LGB_PCUtilizeAnalysis  , [FunctionBit.FunctionLog_AgLogonoff])       // PC活用状況分析

        // 設定
        .set(this.defRestriction.AltSet                 , [FunctionBit.FunctionAlt_Ast, FunctionBit.FunctionAlt_Log])            // アラート設定
        .set(this.defRestriction.AltSet_Ast             , [FunctionBit.FunctionAlt_Ast])            // アラート設定 資産アラート
        .set(this.defRestriction.AltSet_Application     , [FunctionBit.FunctionAlt_Log])            // アラート設定 アプリケーションアラート
        .set(this.defRestriction.AltSet_File            , [FunctionBit.FunctionAlt_Log])            // アラート設定 アラート設定 ファイル操作アラート
        .set(this.defRestriction.AltSet_Other           , [FunctionBit.FunctionLog_FileOperation, FunctionBit.FunctionAlt_Log],)  // アラート設定 その他アラート
        .set(this.defRestriction.LogSet                 , [FunctionBit.FunctionAlt_Log])            // ログ設定
        .set(this.defRestriction.LogSet_Normal          , [FunctionBit.FunctionAlt_Log])            // ログ設定 通常ログ設定
        .set(this.defRestriction.LogSet_DataServer      , [FunctionBit.FunctionAlt_Log])            // ログ設定 データサーバー設定
        .set(this.defRestriction.Wud                    , [FunctionBit.FunctionAst_WindowsUpdateManagement])                     // 更新プログラム配布管理
        .set(this.defRestriction.Wud_Mng                , [FunctionBit.FunctionAst_WindowsUpdateManagement])                     // 更新プログラム配布管理 更新プログラム配布管理 
        .set(this.defRestriction.Wud_Division           , [FunctionBit.FunctionAst_WindowsUpdateManagement])                     // 更新プログラム配布管理 部署別設定
        .set(this.defRestriction.Wud_Common             , [FunctionBit.FunctionAst_WindowsUpdateManagement])                     // 更新プログラム配布管理 共通設定
        .set(this.defRestriction.CsvExp                 , [FunctionBit.FunctionLog_AgLogonoff,      // ログ一括出力
                                                           FunctionBit.FunctionLog_AgOperation,
                                                           FunctionBit.FunctionLog_Application,
                                                           FunctionBit.FunctionLog_FileOperation,
                                                           FunctionBit.FunctionLog_Printer,
                                                           FunctionBit.FunctionLog_Removable,
                                                           FunctionBit.FunctionLog_SendMail,
                                                           FunctionBit.FunctionLog_System,
                                                           FunctionBit.FunctionLog_WebDownload])

    public static getRestrictionRequireLicenseMap(restrictionID: number /* 機能制限ID */): number[] | undefined {
        return this.licenseMap.get(restrictionID);
    }
}

// 機能制限設定（データベース）
export class RestrictionDBData {
    public restrictionID: number;       // 機能制限ID
    public restrictionTreeID: number;   // 機能制限ツリーID
    public restrictionName: string;     // 機能制限名
    public parentID: number;            // 親ツリーID
    public displayOrder: number;        // 表示順序
    public flagReserveDep = false;      // 逆依存（直下の子項目が全制限になった場合は自動で制限に遷移）
    public isDisplay = true;           // 表示の有無（デフォルトは表示）

    constructor(restrictionID?: number, restrictionTreeID?: number, restrictionName?: string, parentID?: number, displayOrder?: number, flagReserveDep?: boolean, isDisplay?: boolean) {
        this.restrictionID = restrictionID ?? 0;
        this.restrictionTreeID = restrictionTreeID ?? 0;
        this.restrictionName = restrictionName ?? "";
        this.parentID = parentID ?? 0;
        this.displayOrder = displayOrder ?? 0;
        this.flagReserveDep = flagReserveDep ?? false;
        this.isDisplay = isDisplay ?? true;
    }

    public equalsObject(_obj: RestrictionDBData): boolean {
        if (this.restrictionID != _obj.restrictionID) return false;
        if (this.restrictionTreeID != _obj.restrictionTreeID) return false;
        if (this.restrictionName != _obj.restrictionName) return false;
        if (this.displayOrder != _obj.displayOrder) return false;
        if (this.parentID != _obj.parentID) return false;
        if (this.flagReserveDep != _obj.flagReserveDep) return false;
        if (this.isDisplay != _obj.isDisplay) return false;
        return true;
    }
}

// 機能制限設定（データベース）
export class RestrictionDBDataMap {

    /// <summary>
    ///  一覧画面ツリー表示用データ 生成処理
    /// @param [in] isCheckMobileiOS : iOSモバイルのチェックが付いているか
    /// @param [in] isCheckMobileAndroid : Androidのチェックが付いているか
    /// @param [in] isEnabledSDVRemoteAccessService : SKYDIV リモートアクセスサービスライセンス有効
    /// @param [in] isEnabledMDM : 紛失制御機能有効
    /// @param [in] isEnabledAIAdvisor : AIアドバイザー機能有効
    /// @param [in] isEnabledPcConditionCheck : PC環境診断機能有効
    /// </summary>
    public static CreateRestrictionDBDataMap(isCheckMobileiOS: boolean, isCheckMobileAndroid: boolean, isEnabledSDVRemoteAccessService: boolean, isEnabledMDM: boolean, isEnabledAIAdvisor: boolean, isEnabledPcConditionCheck: boolean): Array<RestrictionDBData> {
        const defRestriction = new MgrRestrictionDef();
        const restrictionData = new RestrictionData();
        const map = new Array<RestrictionDBData>();
        map.push(new RestrictionDBData(-1, restrictionData.MR_TREECODE_Root, "root", restrictionData.MR_TREECODE_Root, 1));
        map.push(new RestrictionDBData(-1, restrictionData.MR_TREECODE_Ast, "資産管理", restrictionData.MR_TREECODE_Root, 1, true));
        map.push(new RestrictionDBData(defRestriction.AstPCLst, restrictionData.MR_TREECODE_AstPCLst, "ハードウェア一覧", restrictionData.MR_TREECODE_Ast, 1, true));
        map.push(new RestrictionDBData(defRestriction.AstPCLst_PCLst, restrictionData.MR_TREECODE_Hardware, "端末一覧", restrictionData.MR_TREECODE_AstPCLst, 1));
        map.push(new RestrictionDBData(defRestriction.AstPCLst_Edit, restrictionData.MR_TREECODE_Hardware_Edit, "編集（端末一覧の追加・編集／部署移動）", restrictionData.MR_TREECODE_Hardware, 1));
        map.push(new RestrictionDBData(defRestriction.AstPCLst_Delete, restrictionData.MR_TREECODE_Hardware_Delete, "端末削除", restrictionData.MR_TREECODE_Hardware, 3));
        map.push(new RestrictionDBData(defRestriction.AstPCLst_Uninstall, restrictionData.MR_TREECODE_Hardware_Uninstall, "アンインストール許可", restrictionData.MR_TREECODE_Hardware, 4));
        map.push(new RestrictionDBData(defRestriction.BitLocker, restrictionData.MR_TREECODE_Bitlocker, "BitLocker情報確認", restrictionData.MR_TREECODE_AstPCLst, 2));
        map.push(new RestrictionDBData(defRestriction.AstAPInf, restrictionData.MR_TREECODE_AstAPInf, "アプリケーション一覧", restrictionData.MR_TREECODE_Ast, 2, true));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_OfficeSetup, restrictionData.MR_TREECODE_AstAPInf_OfficeSetup, "Office", restrictionData.MR_TREECODE_AstAPInf, 1));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_VirusChecker, restrictionData.MR_TREECODE_AstAPInf_VirusChecker, "ウイルス対策ソフト", restrictionData.MR_TREECODE_AstAPInf, 2));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_AppSetup, restrictionData.MR_TREECODE_AstAPInf_AppSetup, "アプリケーション", restrictionData.MR_TREECODE_AstAPInf, 3));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_WinStoreApp, restrictionData.MR_TREECODE_AstAPInf_WinStoreApp, "Windowsストアアプリ", restrictionData.MR_TREECODE_AstAPInf, 4));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_OSLicense, restrictionData.MR_TREECODE_AstAPInf_OSLicense, "OS", restrictionData.MR_TREECODE_AstAPInf, 5));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_WinPatch, restrictionData.MR_TREECODE_AstAPInf_WinPatch, "Windows更新", restrictionData.MR_TREECODE_AstAPInf, 6));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_Software, restrictionData.MR_TREECODE_AstAPInf_Software, "ソフトウェア配布", restrictionData.MR_TREECODE_AstAPInf, 7));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_Software_Edit, restrictionData.MR_TREECODE_AstAPInf_Software_Edit, "配布するソフトウェアの追加／編集／削除", restrictionData.MR_TREECODE_AstAPInf_Software, 1));
        map.push(new RestrictionDBData(defRestriction.USBDevSet, restrictionData.MR_TREECODE_Device, "デバイス管理", restrictionData.MR_TREECODE_Ast, 3));
        map.push(new RestrictionDBData(defRestriction.USBDevSet_RegUsbDev, restrictionData.MR_TREECODE_USBDevSet_RegUsbDev, "デバイスの登録（インポート）", restrictionData.MR_TREECODE_Device, 1));
        map.push(new RestrictionDBData(defRestriction.USBDevSet_Media_Manage_List_DeviceAlertSet, restrictionData.MR_TREECODE_USBDevSet_DeviceAlertSet, "デバイス種別制御設定／アラート設定", restrictionData.MR_TREECODE_Device, 2));
        map.push(new RestrictionDBData(defRestriction.USBDevSet_Common, restrictionData.MR_TREECODE_USBDevSet_CmnSet, "共通設定", restrictionData.MR_TREECODE_Device, 3));
        map.push(new RestrictionDBData(defRestriction.PcConditionCheck, restrictionData.MR_TREECODE_PcCondnitonCheck, "PC環境診断", restrictionData.MR_TREECODE_Ast, 4, false, isEnabledPcConditionCheck));
        map.push(new RestrictionDBData(defRestriction.PcConditionCheck_Setting, restrictionData.MR_TREECODE_PcCondnitonCheck_Setting, "PC環境診断設定", restrictionData.MR_TREECODE_PcCondnitonCheck, 1));


        map.push(new RestrictionDBData(-1, restrictionData.MR_TREECODE_Log, "ログ管理", restrictionData.MR_TREECODE_Root, 2, true));
        map.push(new RestrictionDBData(defRestriction.LGB, restrictionData.MR_TREECODE_LGB, "ログ閲覧", restrictionData.MR_TREECODE_Log, 1, true));
        map.push(new RestrictionDBData(defRestriction.LGB_AgLogonoff, restrictionData.MR_TREECODE_LGB_AgLogonoff, "起動・終了", restrictionData.MR_TREECODE_LGB, 1));
        map.push(new RestrictionDBData(defRestriction.LGB_ActWnd, restrictionData.MR_TREECODE_LGB_ActWnd, "クライアント操作", restrictionData.MR_TREECODE_LGB, 2));
        map.push(new RestrictionDBData(defRestriction.LGB_Application, restrictionData.MR_TREECODE_LGB_Application, "アプリケーション", restrictionData.MR_TREECODE_LGB, 3));
        map.push(new RestrictionDBData(defRestriction.LGB_FileOperation, restrictionData.MR_TREECODE_LGB_FileOperation, "ファイル操作", restrictionData.MR_TREECODE_LGB, 4));
        map.push(new RestrictionDBData(defRestriction.LGB_NetDevice, restrictionData.MR_TREECODE_LGB_NetDevice, "通信デバイス", restrictionData.MR_TREECODE_LGB, 5));
        map.push(new RestrictionDBData(defRestriction.LGB_System, restrictionData.MR_TREECODE_LGB_System, "システム", restrictionData.MR_TREECODE_LGB, 6));
        map.push(new RestrictionDBData(defRestriction.LGB_Printer, restrictionData.MR_TREECODE_LGB_Printer, "プリント", restrictionData.MR_TREECODE_LGB, 7));
        map.push(new RestrictionDBData(defRestriction.LGB_WebDownload, restrictionData.MR_TREECODE_LGB_WebAcs, "Webアクセス", restrictionData.MR_TREECODE_LGB, 8));
        map.push(new RestrictionDBData(defRestriction.LGB_SendMail, restrictionData.MR_TREECODE_LGB_SendMail, "メール", restrictionData.MR_TREECODE_LGB, 9));
        map.push(new RestrictionDBData(defRestriction.LGB_Removable, restrictionData.MR_TREECODE_LGB_Removable, "ドライブ", restrictionData.MR_TREECODE_LGB, 10));
        map.push(new RestrictionDBData(defRestriction.LGB_IllegalTerminal, restrictionData.MR_TREECODE_LGB_IllegalTerminal, "不許可端末", restrictionData.MR_TREECODE_LGB, 11));
        map.push(new RestrictionDBData(defRestriction.LGB_PCUtilizeAnalysis, restrictionData.MR_TREECODE_LGB_PCUtilizeAnalysis, "PC活用状況分析", restrictionData.MR_TREECODE_Log, 3));

        map.push(new RestrictionDBData(-1, restrictionData.MR_TREECODE_Distribution, "配信", restrictionData.MR_TREECODE_Root, 3, true));
        map.push(new RestrictionDBData(defRestriction.Enquete, restrictionData.MR_TREECODE_Enquete, "アンケート", restrictionData.MR_TREECODE_Distribution, 1, true));
        map.push(new RestrictionDBData(defRestriction.Enquete_Mng, restrictionData.MR_TREECODE_Enquete_Mng, "アンケート管理", restrictionData.MR_TREECODE_Enquete, 1));
        map.push(new RestrictionDBData(defRestriction.Enquete_Common, restrictionData.MR_TREECODE_Enquete_Common, "共通設定", restrictionData.MR_TREECODE_Enquete, 2));
        map.push(new RestrictionDBData(defRestriction.Message, restrictionData.MR_TREECODE_Message, "メッセージ", restrictionData.MR_TREECODE_Distribution, 2, true));
        map.push(new RestrictionDBData(defRestriction.Message_Mng, restrictionData.MR_TREECODE_Message_Mng, "メッセージ管理", restrictionData.MR_TREECODE_Message, 1));
        map.push(new RestrictionDBData(defRestriction.Message_Common, restrictionData.MR_TREECODE_Message_Common, "共通設定", restrictionData.MR_TREECODE_Message, 2));

        map.push(new RestrictionDBData(-1, restrictionData.MR_TREECODE_Setting, "設定", restrictionData.MR_TREECODE_Root, 4, true));
        map.push(new RestrictionDBData(defRestriction.AltSet, restrictionData.MR_TREECODE_AltSet, "アラート設定", restrictionData.MR_TREECODE_Setting, 1, true));
        map.push(new RestrictionDBData(defRestriction.AltSet_Ast, restrictionData.MR_TREECODE_AltSet_Ast, "資産アラート", restrictionData.MR_TREECODE_AltSet, 1));
        map.push(new RestrictionDBData(defRestriction.AltSet_Application, restrictionData.MR_TREECODE_AltSet_Application, "アプリケーションアラート", restrictionData.MR_TREECODE_AltSet, 2));
        map.push(new RestrictionDBData(defRestriction.AltSet_File, restrictionData.MR_TREECODE_AltSet_File, "ファイル操作アラート", restrictionData.MR_TREECODE_AltSet, 3));
        map.push(new RestrictionDBData(defRestriction.AltSet_Other, restrictionData.MR_TREECODE_AltSet_Other, "その他アラート", restrictionData.MR_TREECODE_AltSet, 4));
        map.push(new RestrictionDBData(defRestriction.AltSet_Common, restrictionData.MR_TREECODE_AltSet_Common, "共通設定", restrictionData.MR_TREECODE_AltSet, 5));
        map.push(new RestrictionDBData(defRestriction.AstSet, restrictionData.MR_TREECODE_AstSet, "資産設定", restrictionData.MR_TREECODE_Setting, 2, true));
        map.push(new RestrictionDBData(defRestriction.AstSet_Division, restrictionData.MR_TREECODE_AstSet_DivSet, "部署別設定", restrictionData.MR_TREECODE_AstSet, 1));
        map.push(new RestrictionDBData(defRestriction.AstSet_Common, restrictionData.MR_TREECODE_AstSet_CmnSet, "共通設定", restrictionData.MR_TREECODE_AstSet, 2));
        map.push(new RestrictionDBData(defRestriction.LogSet, restrictionData.MR_TREECODE_LogSet, "ログ設定", restrictionData.MR_TREECODE_Setting, 3, true));
        map.push(new RestrictionDBData(defRestriction.LogSet_Normal, restrictionData.MR_TREECODE_LogSet_Normal, "通常ログ設定", restrictionData.MR_TREECODE_LogSet, 1));
        map.push(new RestrictionDBData(defRestriction.LogSet_DataServer, restrictionData.MR_TREECODE_LogSet_DataServer, "データサーバー設定", restrictionData.MR_TREECODE_LogSet, 2));
        map.push(new RestrictionDBData(defRestriction.OprSet, restrictionData.MR_TREECODE_OpeSet, "運用設定", restrictionData.MR_TREECODE_Setting, 4, true));
        map.push(new RestrictionDBData(defRestriction.OprSet_Common, restrictionData.MR_TREECODE_OpeSet_CmnSet, "共通設定", restrictionData.MR_TREECODE_OpeSet, 1, true));
        map.push(new RestrictionDBData(defRestriction.OprSet_Common_Division, restrictionData.MR_TREECODE_OpeSet_CmnSet_EditDiv, "部署一覧の編集", restrictionData.MR_TREECODE_OpeSet_CmnSet, 1));
        map.push(new RestrictionDBData(defRestriction.OprSet_Common_Dashboard, restrictionData.MR_TREECODE_OpeSet_CmnSet_DashboardSet, "ダッシュボード設定", restrictionData.MR_TREECODE_OpeSet_CmnSet, 2));
        map.push(new RestrictionDBData(defRestriction.OprSet_Download, restrictionData.MR_TREECODE_OpeSet_Download, "ダウンロード", restrictionData.MR_TREECODE_OpeSet, 2, true));
        map.push(new RestrictionDBData(defRestriction.OprSet_Download_Agent, restrictionData.MR_TREECODE_OpeSet_Download_Scv, "SKYSEA端末機のインストーラー", restrictionData.MR_TREECODE_OpeSet_Download, 1));
        map.push(new RestrictionDBData(defRestriction.WinUpdSet, restrictionData.MR_TREECODE_WinUpdSet, "Windows更新制御", restrictionData.MR_TREECODE_Setting, 5));
        map.push(new RestrictionDBData(defRestriction.Wud, restrictionData.MR_TREECODE_Wud, "更新プログラム配布管理", restrictionData.MR_TREECODE_Setting, 6, true));
        map.push(new RestrictionDBData(defRestriction.Wud_Mng, restrictionData.MR_TREECODE_Wud_Mng, "更新プログラム配布管理", restrictionData.MR_TREECODE_Wud, 1));
        map.push(new RestrictionDBData(defRestriction.Wud_Division, restrictionData.MR_TREECODE_Wud_Division, "部署別設定", restrictionData.MR_TREECODE_Wud, 2));
        map.push(new RestrictionDBData(defRestriction.Wud_Common, restrictionData.MR_TREECODE_Wud_Common, "共通設定", restrictionData.MR_TREECODE_Wud, 3));
        map.push(new RestrictionDBData(defRestriction.CsvExp, restrictionData.MR_TREECODE_LogExport, "ログ一括出力", restrictionData.MR_TREECODE_Setting, 7));
        map.push(new RestrictionDBData(defRestriction.LicenseInfo, restrictionData.MR_TREECODE_License, "ライセンス情報／利用状況（マイページ）", restrictionData.MR_TREECODE_Root, 4));
        map.push(new RestrictionDBData(defRestriction.AIAdvisor, restrictionData.MR_TREECODE_AIAdvisor, "AIアドバイザー", restrictionData.MR_TREECODE_Root, 5, false, isEnabledAIAdvisor));


        // isCheckMobileiOS
        map.push(new RestrictionDBData(defRestriction.AstPCLst_Mobile_iOS_Data, restrictionData.MR_TREECODE_Hardware_Mbl_iOS_Data, "モバイル端末（iOS）のデータ取得", restrictionData.MR_TREECODE_Hardware, 6, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_MobileEMMDistributeApp, restrictionData.MR_TREECODE_AstAPInf_iOS_AppMng, "iOSアプリ管理", restrictionData.MR_TREECODE_AstAPInf, 9, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_MobileEMM_iOS_DistributeBook, restrictionData.MR_TREECODE_AstAPInf_iOS_DistributeBook, "iOSブック配布", restrictionData.MR_TREECODE_AstAPInf, 10, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_MobileEMM_iOS_OSUpdate, restrictionData.MR_TREECODE_AstAPInf_iOS_OSUpdate, "iOSアップデート", restrictionData.MR_TREECODE_AstAPInf, 11, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.MBLSET_iOS, restrictionData.MR_TREECODE_MblSet_iOS, "iOS用設定", restrictionData.MR_TREECODE_MblSet, 1, true, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.MBLSET_iOS_Alt, restrictionData.MR_TREECODE_MblSet_iOS_AltSet, "アラート設定", restrictionData.MR_TREECODE_MblSet_iOS, 1, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.MBLSET_iOS_EMM_Profile, restrictionData.MR_TREECODE_MblSet_iOS_ProfileSet, "構成プロファイル設定", restrictionData.MR_TREECODE_MblSet_iOS, 2, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.MBLSET_iOS_EMM_Profile_Common, restrictionData.MR_TREECODE_MblSet_iOS_ProfileSet_Reference, "参照用構成プロファイルの追加／編集／削除", restrictionData.MR_TREECODE_MblSet_iOS_ProfileSet, 1, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.MBLSET_iOS_Ast, restrictionData.MR_TREECODE_MblSet_iOS_AstSet, "資産設定", restrictionData.MR_TREECODE_MblSet_iOS, 3, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.MBLSET_iOS_VPP, restrictionData.MR_TREECODE_MblSet_iOS_VppSet, "VPP設定", restrictionData.MR_TREECODE_MblSet_iOS, 4, false, isCheckMobileiOS));
        map.push(new RestrictionDBData(defRestriction.MBLSET_iOS_Common, restrictionData.MR_TREECODE_MblSet_iOS_CmnSet, "共通設定", restrictionData.MR_TREECODE_MblSet_iOS, 5, false, isCheckMobileiOS));

        // isCheckMobileAndroid
        map.push(new RestrictionDBData(defRestriction.AstAPInf_MobileEMM_Android_APPMng, restrictionData.MR_TREECODE_AstAPInf_Android_AppMng, "Androidアプリ管理", restrictionData.MR_TREECODE_AstAPInf, 12, false, isCheckMobileAndroid));
        map.push(new RestrictionDBData(defRestriction.MBLSET_Android, restrictionData.MR_TREECODE_MblSet_Android, "Android用設定", restrictionData.MR_TREECODE_MblSet, 2, true, isCheckMobileAndroid));
        map.push(new RestrictionDBData(defRestriction.MBLSET_Android_EMM_Policy, restrictionData.MR_TREECODE_MblSet_Android_MDMPolicySet, "MDMポリシー設定", restrictionData.MR_TREECODE_MblSet_Android, 1, false, isCheckMobileAndroid));
        map.push(new RestrictionDBData(defRestriction.MBLSET_Android_Common, restrictionData.MR_TREECODE_MblSet_Android_CmnSet, "共通設定", restrictionData.MR_TREECODE_MblSet_Android, 2, false, isCheckMobileAndroid));

        // isCheckMobileiOS || isCheckMobileAndroid
        map.push(new RestrictionDBData(defRestriction.AstPCLst_Mobile, restrictionData.MR_TREECODE_Hardware_MblCtl, "モバイル端末登録", restrictionData.MR_TREECODE_Hardware, 5, false, isCheckMobileiOS || isCheckMobileAndroid));
        map.push(new RestrictionDBData(defRestriction.AstPCLst_Mobile_ADE, restrictionData.MR_TREECODE_Hardware_MblCtl_ADEProfile, "ADEプロファイルの追加／編集／削除", restrictionData.MR_TREECODE_Hardware_MblCtl, 1, false, isCheckMobileiOS || isCheckMobileAndroid));
        map.push(new RestrictionDBData(defRestriction.AstPCLst_Mobile_Control, restrictionData.MR_TREECODE_Hardware_MblCtl_Control, "モバイル端末制御", restrictionData.MR_TREECODE_Hardware, 7, false, isCheckMobileiOS || isCheckMobileAndroid));
        map.push(new RestrictionDBData(defRestriction.AstAPInf_MobileApp, restrictionData.MR_TREECODE_AstAPInf_MobileApp, "モバイルアプリ", restrictionData.MR_TREECODE_AstAPInf, 8, false, isCheckMobileiOS || isCheckMobileAndroid));
        map.push(new RestrictionDBData(defRestriction.EMMLocationInfoMng, restrictionData.MR_TREECODE_LocationManage, "モバイル端末位置情報管理", restrictionData.MR_TREECODE_Log, 2, false, isCheckMobileiOS || isCheckMobileAndroid));
        map.push(new RestrictionDBData(defRestriction.MBLSET, restrictionData.MR_TREECODE_MblSet, "モバイル設定", restrictionData.MR_TREECODE_Setting, 8, true, isCheckMobileiOS || isCheckMobileAndroid));

        // isEnabledSDVRemoteAccessService
        map.push(new RestrictionDBData(defRestriction.AstPCLst_Rcv, restrictionData.MR_TREECODE_Hardware_RCV, "リモート操作", restrictionData.MR_TREECODE_Hardware, 2, false, isEnabledSDVRemoteAccessService));
        map.push(new RestrictionDBData(defRestriction.OprSet_Download_Remote, restrictionData.MR_TREECODE_OpeSet_Download_Remote, "利用者側操作PC（SKYDIVリモートアクセスサービス）のインストーラー", restrictionData.MR_TREECODE_OpeSet_Download, 2, false, isEnabledSDVRemoteAccessService));

        // isEnabledMDM
        map.push(new RestrictionDBData(defRestriction.AstPCLst_MDMSet, restrictionData.MR_TREECODE_Hardware_MDMSetWeb, "紛失端末制御", restrictionData.MR_TREECODE_Hardware, 8, false, isEnabledMDM));
        map.push(new RestrictionDBData(defRestriction.MDMSetWeb, restrictionData.MR_TREECODE_MDMStatus, "紛失端末制御状況", restrictionData.MR_TREECODE_AstPCLst, 3, false, isEnabledMDM));
        map.push(new RestrictionDBData(defRestriction.MDMSet, restrictionData.MR_TREECODE_MDMSet, "紛失端末制御設定", restrictionData.MR_TREECODE_Setting, 6, true, isEnabledMDM));
        map.push(new RestrictionDBData(defRestriction.MDMSet_Division, restrictionData.MR_TREECODE_MDMSet_DivSet, "部署別設定", restrictionData.MR_TREECODE_MDMSet, 1, false, isEnabledMDM));
        map.push(new RestrictionDBData(defRestriction.MDMSet_Common, restrictionData.MR_TREECODE_MDMSet_CmnSet, "共通設定", restrictionData.MR_TREECODE_MDMSet, 2, false, isEnabledMDM));

        // mapに詰めた全機能制限項目からライセンスがあるものを抽出
        const userSettingStore = useUserSettingStore();
        map.forEach(r => {
            // 機能制限項目とライセンスの紐づけがない場合はライセンス不要と判断
            const licenseMap = RestrictionRequireLicense.getRestrictionRequireLicenseMap(r.restrictionID)
            if (undefined == licenseMap) {
                return;
            }

            // ライセンスが有効判定
            for (const functionBit of licenseMap) {
                if (userSettingStore.scvLicenseManager.isLicenseEnable(functionBit)) {
                    r.isDisplay = true;
                    return;
                }
            }
            r.isDisplay = false;
            return;
        })

        return map;
    }
}

// 部署設定（UI用に扱いやすいようにしたデータクラス）
export class RestrictionData {
    public restrictionBit: number;      // 機能制限項目ID（ビット値の桁）
    public restrictionTreeID: number;   // 機能制限ツリーID
    public restrictionName: string;     // 機能制限名
    public arChildren: Array<RestrictionData> = new Array<RestrictionData>(); // 子要素

    // オプション変数
    public alertAgentCount: number; // アラート端末数
    public checkState: number; // チェック状態
    public flagReserveDep = false; // 逆依存（直下の子項目が全制限になった場合は自動で制限に遷移）
    public isDisplay = true;           // 表示の有無（デフォルトは表示）

    // 状態
    public static STATE_APPROVAL = 0;        // 許可
    public static STATE_DISAPPROVAL = 1;        // 制限
    public static STATE_MIXED = 2;        // 混在



    // ツリー用機能制限項目コード
    public readonly MR_TREECODE_Root = 0; // root
    public readonly MR_TREECODE_Ast = 1; // 資産管理
    public readonly MR_TREECODE_Log = 2; // ログ管理
    public readonly MR_TREECODE_Setting = 3; // 設定
    public readonly MR_TREECODE_Other = 4; // その他
    public readonly MR_TREECODE_AstPCLst = 5; // ハードウェア一覧
    public readonly MR_TREECODE_AstAPInf = 6; // アプリケーション一覧
    public readonly MR_TREECODE_Device = 7; // デバイス管理
    public readonly MR_TREECODE_LGB = 8; // ログ閲覧
    public readonly MR_TREECODE_LocationManage = 9; // 位置情報管理
    public readonly MR_TREECODE_AltSet = 10; // アラート設定
    public readonly MR_TREECODE_AstSet = 11; // 資産設定
    public readonly MR_TREECODE_LogSet = 12; // ログ設定
    public readonly MR_TREECODE_OpeSet = 13; // 運用設定
    public readonly MR_TREECODE_MDMSet = 14; // 紛失端末制御設定
    public readonly MR_TREECODE_LogExport = 15; // ログ一括出力
    public readonly MR_TREECODE_MblSet = 16; // モバイル設定
    public readonly MR_TREECODE_License = 17; // ライセンス情報
    public readonly MR_TREECODE_Hardware = 18; // 端末一覧
    public readonly MR_TREECODE_Bitlocker = 19; // BitLocker情報確認
    public readonly MR_TREECODE_MDMStatus = 20; // 紛失端末制御状況
    public readonly MR_TREECODE_AstAPInf_OfficeSetup = 21; // Office
    public readonly MR_TREECODE_AstAPInf_VirusChecker = 22; // ウイルス対策ソフト
    public readonly MR_TREECODE_AstAPInf_AppSetup = 23; // アプリケーション
    public readonly MR_TREECODE_AstAPInf_WinStoreApp = 24; // Windowsストアアプリ
    public readonly MR_TREECODE_AstAPInf_OSLicense = 25; // OS
    public readonly MR_TREECODE_AstAPInf_WinPatch = 26; // Windows更新
    public readonly MR_TREECODE_AstAPInf_Software = 27; // ソフトウェア配布
    public readonly MR_TREECODE_AstAPInf_MobileApp = 28; // モバイルアプリ
    public readonly MR_TREECODE_AstAPInf_iOS_AppMng = 29; // iOSアプリ管理
    public readonly MR_TREECODE_AstAPInf_iOS_OSUpdate = 30; // iOSアップデート
    public readonly MR_TREECODE_AstAPInf_Android_AppMng = 31; // Androidアプリ管理
    public readonly MR_TREECODE_USBDevSet_RegUsbDev = 32; // USBデバイス登録
    public readonly MR_TREECODE_USBDevSet_DeviceAlertSet = 33; // デバイス種別制御設定／アラート設定
    public readonly MR_TREECODE_USBDevSet_CmnSet = 34; // 共通設定
    public readonly MR_TREECODE_LGB_AgLogonoff = 35; // 起動・終了
    public readonly MR_TREECODE_LGB_Application = 36; // アプリケーション
    public readonly MR_TREECODE_LGB_FileOperation = 37; // ファイル操作
    public readonly MR_TREECODE_LGB_System = 38; // システム
    public readonly MR_TREECODE_LGB_Printer = 39; // プリント
    public readonly MR_TREECODE_LGB_WebAcs = 40; // Webアクセス
    public readonly MR_TREECODE_LGB_Removable = 41; // ドライブ
    public readonly MR_TREECODE_AltSet_Ast = 42; // 資産アラート
    public readonly MR_TREECODE_AltSet_Application = 43; // アプリケーションアラート
    public readonly MR_TREECODE_AltSet_File = 44; // ファイル操作アラート
    public readonly MR_TREECODE_AltSet_Other = 45; // その他アラート
    public readonly MR_TREECODE_AstSet_DivSet = 46; // 部署別設定
    public readonly MR_TREECODE_AstSet_CmnSet = 47; // 共通設定
    public readonly MR_TREECODE_LogSet_Normal = 48; // 通常ログ設定
    public readonly MR_TREECODE_LogSet_DataServer = 49; // データサーバー設定
    public readonly MR_TREECODE_OpeSet_CmnSet = 50; // 共通設定
    public readonly MR_TREECODE_OpeSet_Download = 51; // ダウンロード
    public readonly MR_TREECODE_MDMSet_DivSet = 52; // 部署別設定
    public readonly MR_TREECODE_MDMSet_CmnSet = 53; // 共通設定
    public readonly MR_TREECODE_MblSet_iOS = 54; // iOS用設定
    public readonly MR_TREECODE_MblSet_Android = 55; // Android用設定
    public readonly MR_TREECODE_Hardware_Edit = 56; // 編集（インポート／端末情報の編集／部署移動／アラート状態解除）
    public readonly MR_TREECODE_Hardware_Delete = 57; // 端末削除
    public readonly MR_TREECODE_Hardware_Uninstall = 58; // アンインストール許可
    public readonly MR_TREECODE_Hardware_MblCtl = 59; // モバイル端末登録
    public readonly MR_TREECODE_Hardware_Mbl_iOS_Data = 60; // モバイル端末(iOS)のデータ取得
    public readonly MR_TREECODE_Hardware_MblCtl_Control = 61; // モバイル端末制御
    public readonly MR_TREECODE_Hardware_RCV = 62; // リモート操作
    public readonly MR_TREECODE_Hardware_MDMSetWeb = 63; // 紛失端末制御
    public readonly MR_TREECODE_AstAPInf_Software_Edit = 64; // 編集（ソフトウェア追加／編集／削除）
    public readonly MR_TREECODE_OpeSet_CmnSet_EditDiv = 65; // 部署一覧の編集
    public readonly MR_TREECODE_OpeSet_CmnSet_DashboardSet = 66; // ダッシュボード設定
    public readonly MR_TREECODE_OpeSet_Download_Scv = 67; // SKYSEA端末機のインストーラ-／アンインストーラー
    public readonly MR_TREECODE_OpeSet_Download_Remote = 68; // 利用者側操作PC（SKYDIV）リモートアクセスサービスのインストーラ－／アンインストーラー
    public readonly MR_TREECODE_MblSet_iOS_AltSet = 69; // アラート設定
    public readonly MR_TREECODE_MblSet_iOS_ProfileSet = 70; // 構成プロファイル設定
    public readonly MR_TREECODE_MblSet_iOS_AstSet = 71; // 資産設定
    public readonly MR_TREECODE_MblSet_iOS_VppSet = 72; // VPP設定
    public readonly MR_TREECODE_MblSet_iOS_CmnSet = 73; // 共通設定
    public readonly MR_TREECODE_MblSet_Android_MDMPolicySet = 74; // MDMポリシー設定
    public readonly MR_TREECODE_MblSet_Android_CmnSet = 75; // 共通設定
    public readonly MR_TREECODE_Hardware_MblCtl_ADEProfile = 76; // ADEプロファイルの編集（全部署共通設定）
    public readonly MR_TREECODE_MblSet_iOS_ProfileSet_Reference = 77; // 参照用構成プロファイル（全部署共通設定）
    public readonly MR_TREECODE_AstAPInf_iOS_DistributeBook = 78; // iOSブック配布
    public readonly MR_TREECODE_LGB_ActWnd = 79;	// ログ閲覧 クライアント操作
    public readonly MR_TREECODE_LGB_NetDevice = 80;	// ログ閲覧 通信デバイス
    public readonly MR_TREECODE_LGB_SendMail = 81;	// ログ閲覧 メール
    public readonly MR_TREECODE_AltSet_Common = 82; // アラート設定 - 共通設定
    public readonly MR_TREECODE_LGB_PCUtilizeAnalysis = 83; // PC活用状況分析
    public readonly MR_TREECODE_WinUpdSet = 84;     // Windows更新制御
    public readonly MR_TREECODE_AIAdvisor = 85; //AIアドバイザー
    public readonly MR_TREECODE_PcCondnitonCheck = 86; // PC環境診断
    public readonly MR_TREECODE_Distribution = 87; // 配信
    public readonly MR_TREECODE_Enquete = 88; // アンケート
    public readonly MR_TREECODE_Enquete_Mng = 89; // アンケート管理
    public readonly MR_TREECODE_Enquete_Common = 90; // アンケート 共通設定
    public readonly MR_TREECODE_Message = 91; // メッセージ
    public readonly MR_TREECODE_Message_Mng = 92; // メッセージ管理
    public readonly MR_TREECODE_Message_Common = 93; // メッセージ 共通設定
    public readonly MR_TREECODE_PcCondnitonCheck_Setting = 94; // PC環境診断 設定
    public readonly MR_TREECODE_LGB_IllegalTerminal = 95;	// ログ閲覧 不許可端末
    public readonly MR_TREECODE_Wud = 96; // 更新プログラム配布管理
    public readonly MR_TREECODE_Wud_Mng = 97; // 更新プログラム配布管理 更新プログラム配布管理
    public readonly MR_TREECODE_Wud_Division = 98; // 更新プログラム配布管理 部署別設定
    public readonly MR_TREECODE_Wud_Common = 99; // 更新プログラム配布管理 共通設定

    constructor(restrictionBit?: number, restrictionTreeID?: number, restrictionName?: string, alertAgentCount?: number, checkState?: number, flagReserveDep?: boolean, isDisplay?: boolean) {
        this.restrictionBit = restrictionBit ?? 0;
        this.restrictionTreeID = restrictionTreeID ?? 0;
        this.restrictionName = restrictionName ?? "";
        this.alertAgentCount = alertAgentCount ?? 0;
        this.checkState = checkState ?? RestrictionData.STATE_APPROVAL;
        this.flagReserveDep = flagReserveDep ?? false;
        this.isDisplay = isDisplay ?? true;
    }

    public UpdateCheckState(restrictionSetting: MgrRestriction): void {
        if (0 <= this.restrictionBit) {
            if (restrictionSetting.GetMixedBit(this.restrictionBit)) {
                // 混在状態
                this.checkState = RestrictionData.STATE_MIXED;
            }
            else {
                this.checkState = restrictionSetting.Get(this.restrictionBit) ? RestrictionData.STATE_APPROVAL : RestrictionData.STATE_DISAPPROVAL;
            }
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].UpdateCheckState(restrictionSetting);
        }

        if (this.restrictionBit < 0) {
            // ビット値の割り振られていない項目は子項目反映完了後に逆算する
            let state = RestrictionData.STATE_DISAPPROVAL;
            for (let i = 0; i < this.arChildren.length; i++) {
                if (this.arChildren[i].checkState === RestrictionData.STATE_APPROVAL) {
                    // 一つでも許可があれば許可
                    state = this.arChildren[i].checkState;
                    break;
                }
                else if (this.arChildren[i].checkState === RestrictionData.STATE_MIXED) {
                    // 許可1つもなく、混在があれば混在
                    state = this.arChildren[i].checkState;
                }
                else {
                    // すべて禁止なら禁止
                }
            }

            this.checkState = state;
        }

        return;
    }

    public MergeCheckState(data: RestrictionData): void {
        if (this.restrictionTreeID === data.restrictionTreeID) {
            this.checkState = (this.checkState === data.checkState) ? this.checkState : RestrictionData.STATE_MIXED;
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            // thisとdataは同じ構造のはず
            let tmpDataArr = data.arChildren.filter(item => item.restrictionTreeID === this.arChildren[i].restrictionTreeID);
            if (0 < tmpDataArr.length) {
                this.arChildren[i].MergeCheckState(tmpDataArr[0]);
            }
        }

        return;
    }

    public GetMgrRestriction(restriction: MgrRestriction) {
        if (0 <= this.restrictionBit) {
            if (this.checkState === RestrictionData.STATE_APPROVAL) {
                restriction.Set(this.restrictionBit);
            }
            else {
                restriction.Clear(this.restrictionBit);
            }
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].GetMgrRestriction(restriction);
        }
    }

    public GetMixedSerial(restriction: MgrRestriction) {
        if (0 <= this.restrictionBit) {
            if (this.checkState === RestrictionData.STATE_MIXED) {
                restriction.SetMixedBit(this.restrictionBit);
            }
            else {
                restriction.ClearMixedBit(this.restrictionBit);
            }
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].GetMixedSerial(restriction);
        }
    }

    /// <summary>
    /// 初期化
    /// </summary>
    public SetDefault(): void {
        this.restrictionBit = 0;
        this.restrictionTreeID = 0;
        this.restrictionName = "";
        this.alertAgentCount = 0;
        this.checkState = RestrictionData.STATE_DISAPPROVAL;
        this.flagReserveDep = false;
        this.isDisplay = true;
        this.arChildren = new Array<RestrictionData>();
    }

    /// <summary>
    /// データベースの情報をデータクラスに変換します
    /// @param [in] arDivList : データベースのデータ
    /// @param [in] arAlertAgentCount : 部署と所属するアラート端末数（アラート状態を部署ツリーに反映した場合）
    /// </summary>
    public Load(
        arDivList: Array<RestrictionDBData>
    ): void {
        // 各編集を初期化
        this.SetDefault();

        // ここで表示順にソートしておくことで、下では順序を意識せずに追加できる
        arDivList.sort(function (a, b) {
            // 大文字、小文字は区別する
            if (a.parentID < b.parentID) {
                return -1;
            }
            if (a.parentID > b.parentID) {
                return 1;
            }
            if (a.displayOrder < b.displayOrder) {
                return -1;
            }
            if (a.displayOrder > b.displayOrder) {
                return 1;
            }

            return 0;
        });

        const divMap = new Map<number, RestrictionData>();         // 部署情報のインスタンスマップ（キーは部署ID）
        const arCacheItem = new Array<RestrictionDBData>();        // 一巡目では親が見つからなかった部署

        // まずは全部署情報を作成する
        const nCount = arDivList.length;
        for (let i = 0; i < nCount; i++) {

            let item = new RestrictionData();
            if (0 == arDivList[i].restrictionTreeID) {
                // ネットワーク全体の場合はthisを代入
                /* eslint @typescript-eslint/no-this-alias: 0 */
                item = this;
            }

            item.restrictionBit = arDivList[i].restrictionID;
            item.restrictionTreeID = arDivList[i].restrictionTreeID;
            item.restrictionName = arDivList[i].restrictionName;
            item.flagReserveDep = arDivList[i].flagReserveDep;
            item.isDisplay = arDivList[i].isDisplay;
            divMap.set(arDivList[i].restrictionTreeID, item);

            if (0 == arDivList[i].restrictionTreeID) {
                // ネットワーク全体の場合は親はいない
                continue;
            }

            // 部署の親子関係を紐づけ
            const parent = divMap.get(arDivList[i].parentID);
            if (undefined == parent) {
                // まだ親が作成されていないので、キャッシュしておく
                arCacheItem.push(arDivList[i]);
                continue;
            }
            parent.arChildren.push(item);
        }

        // ここまでくれば全部署情報が作成されているので、
        // 一巡目で親が見つからなかった部署も、見つかるはず
        const nCacheCount = arCacheItem.length;
        for (let i = 0; i < nCacheCount; i++) {
            const divItem = divMap.get(arCacheItem[i].restrictionTreeID);
            if (undefined == divItem) {
                continue;
            }

            const parent = divMap.get(arCacheItem[i].parentID);
            if (undefined == parent) {
                // ここでも作成されていない場合はあきらめる
                continue;
            }
            parent.arChildren.push(divItem);
        }
    }

    ///// <summary>
    ///// データクラスをデータベースの情報に変換します
    ///// @param [out] arDivList : データベース情報
    ///// </summary>
    //public Save(arDivList: Array<DivisionDBData>): void {
    //    const item = new DivisionDBData();
    //    item.restrictionBit = this.restrictionBit;
    //    item.restrictionName = this.restrictionName;
    //    item.parentID = 0;
    //    item.displayOrder = 1;
    //    arDivList.push(item);

    //    this.SaveChildren(arDivList);
    //}

    ///// <summary>
    ///// データクラスをデータベースの情報に変換します（子部署）
    ///// @param [out] arDivList : データベース情報
    ///// </summary>
    //public SaveChildren(arDivList: Array<DivisionDBData>): void {
    //    for (let i = 0; i < this.arChildren.length; i++) {
    //        const item = new DivisionDBData();
    //        item.restrictionBit = this.arChildren[i].restrictionBit;
    //        item.restrictionName = this.arChildren[i].restrictionName;
    //        item.parentID = this.restrictionBit;
    //        item.displayOrder = i + 1;

    //        arDivList.push(item);

    //        this.arChildren[i].SaveChildren(arDivList);
    //    }
    //}

    /**
     * 指定された部署IDの部署情報を返します
     * @param[in] nRestrictionTreeID : 部署ID
     * @return undefined:見つからなかった undefined以外：部署ID
     */
    public GetRestrictionData(nRestrictionTreeID: number): RestrictionData | undefined {
        if (this.restrictionTreeID == nRestrictionTreeID) {
            return this;
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            const ret = this.arChildren[i].GetRestrictionData(nRestrictionTreeID);
            if (undefined != ret) {
                return ret;
            }
        }

        return undefined;
    }

    /**
     * 指定された部署IDの親部署情報を返します
     * @param[in] nRestrictionTreeID : 部署ID
     * @return undefined:見つからなかった undefined以外：部署ID
     */
    public GetParentRestrictionData(nRestrictionTreeID: number): RestrictionData | undefined {
        if (this.restrictionTreeID == nRestrictionTreeID) {
            // 自分は親ではない
            return undefined;
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            if (this.arChildren[i].restrictionTreeID == nRestrictionTreeID) {
                // 自分の子
                return this;
            }

            const ret = this.arChildren[i].GetParentRestrictionData(nRestrictionTreeID);
            if (undefined != ret) {
                // 孫以上
                return ret;
            }
        }

        return undefined;
    }

    /**
     * 指定された部署IDの子部署を削除します
     * @param[in] nRestrictionTreeID : 部署ID
     * @return true : 削除        false : 対象が見つからない
     */
    public DeleteChildRestrictionData(nRestrictionTreeID: number): boolean {
        for (let i = 0; i < this.arChildren.length; i++) {
            if (this.arChildren[i].restrictionTreeID == nRestrictionTreeID) {
                this.arChildren.splice(i, 1);
                return true;
            }

            const ret = this.arChildren[i].DeleteChildRestrictionData(nRestrictionTreeID);
            if (true == ret) {
                return ret;
            }
        }

        return false;
    }

    /**
     * 部署ID一覧を取得します
     * @param[out] arRestrictionTreeID : 部署ID一覧
     */
    public GetAllRestrictionBit(arRestrictionTreeID: Array<number>): void {
        arRestrictionTreeID.push(this.restrictionTreeID);

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].GetAllRestrictionBit(arRestrictionTreeID);
        }
    }

    /**
     * 階層を取得します
     * @param[in] nRestrictionTreeID : 部署ID
     * @param[out] nResult : 結果（階層）
     */
    public GetHierarchy(nRestrictionTreeID: number): number {
        if (this.restrictionTreeID == nRestrictionTreeID) {
            return 1;
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            if (this.arChildren[i].restrictionTreeID == nRestrictionTreeID) {
                // 自分の子
                return 2;
            }

            const ret = this.arChildren[i].GetHierarchy(nRestrictionTreeID);
            if (0 != ret) {
                // 孫以上
                return ret + 1;
            }
        }

        return 0;
    }

    /**
     * 配下部署が何階層あるかを取得します
     * @return : 結果（階層）※自分を含めての値
     */
    public GetChildrenHierarchy(): number {
        let nChild = 0;

        for (let i = 0; i < this.arChildren.length; i++) {
            const nTemp = this.arChildren[i].GetChildrenHierarchy();

            if (nChild < nTemp) {
                nChild = nTemp;
            }
        }

        // 最後に自分を含める
        return nChild + 1;
    }

    /**
     * 子部署のチェック状態を変更する
     * @param[in] check : チェック状態
     */
    public CheckChildRestriction(check: number): void {
        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].checkState = check;

            this.arChildren[i].CheckChildRestriction(check);
        }
    }

    /**
     * 対象を指定してチェック状態を変更する
     * @param[in] restrictionIDs : チェックがオンの部署ID
     */
    public SetCheckTargetRestriction(restrictionIDs: Array<number>, checkState: boolean): void {
        if (restrictionIDs.includes(this.restrictionBit)) {
            this.checkState = checkState ? RestrictionData.STATE_APPROVAL : RestrictionData.STATE_DISAPPROVAL;
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].SetCheckTargetRestriction(restrictionIDs, checkState);
        }
    }

    /**
     * チェック状態を変更する
     * @param[in] restrictionIDs : チェックがオンの部署ID
     */
    public SetCheckAllRestriction(restrictionIDs: Array<number>): void {
        if (restrictionIDs.includes(this.restrictionBit)) {
            this.checkState = RestrictionData.STATE_APPROVAL;
        }
        else {
            this.checkState = RestrictionData.STATE_DISAPPROVAL;
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].SetCheckAllRestriction(restrictionIDs);
        }
    }

    /**
     * チェック状態を取得する
     * @param[out] restrictionIDs : チェックがオンの機能制限ID
     */
    public GetCheckAllRestriction(restrictionIDs: Array<number>): void {
        if (this.checkState === RestrictionData.STATE_APPROVAL) {
            restrictionIDs.push(this.restrictionBit);
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].GetCheckAllRestriction(restrictionIDs);
        }
    }

    /**
     * チェック状態がオフの項目を取得する
     * @param[out] restrictionIDs : チェックがオフの機能制限ID
     */
    public GetCheckOffAllRestriction(restrictionIDs: Array<number>): void {
        if (this.checkState === RestrictionData.STATE_DISAPPROVAL) {
            restrictionIDs.push(this.restrictionBit);
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].GetCheckOffAllRestriction(restrictionIDs);
        }
    }

    /**
     * 対象IDに該当する項目のチェック状態を取得する
     * @param[in]   targetId : 検索対象の機能制限ID
     * @retval      対象の状態（未発見の場合は-1）
     */
    public GetTargetRestrictionState(targetId: number): number {
        if (this.restrictionBit === targetId) {
            // 対象項目のみ実行
            return this.checkState;
        }

        let state = -1;
        for (let i = 0; i < this.arChildren.length; i++) {
            state = this.arChildren[i].GetTargetRestrictionState(targetId);
            if (RestrictionData.STATE_APPROVAL <= state) {
                return state;
            }
        }

        return -1;
    }

    public GetRestrictionSerial(): number {
        let serial = 0
        if (0 < this.arChildren.length) {
            for (let i = 0; i < this.arChildren.length; i++) {
                serial |= this.arChildren[i].GetRestrictionSerial();
            }
        }



        return serial;
    }

    public GetChildrenID(childrenId: Array<number>) {
        for (let i = 0; i < this.arChildren.length; i++) {
            childrenId.push(this.arChildren[i].restrictionBit);
            this.arChildren[i].GetChildrenID(childrenId);
        }
    }

    // 対象の配下項目IDを取得
    public GetTargetChildrenID(targetId: number, childrenId: Array<number>) {
        if (this.restrictionBit === targetId) {
            // 対象項目のみ実行
            this.GetChildrenID(childrenId);
            return;
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].GetTargetChildrenID(targetId, childrenId);
        }
    }

    // 対象の先祖項目IDを取得
    public GetTargetAncestorID(targetId: number, ancestorId: Array<number>) {
        let childIds = new Array<number>();
        this.GetChildrenID(childIds);
        if (childIds.includes(targetId)) {
            ancestorId.push(this.restrictionBit);
            for (let i = 0; i < this.arChildren.length; i++) {
                this.arChildren[i].GetTargetAncestorID(targetId, ancestorId);
            }
        }
    }

    // 逆依存のケースに当てはまるかどうかチェック
    public IsReserveDepCase(targetId: number, itemArray: Array<number>): boolean {
        // 逆依存のケースに当てはまるかを判定（許可→禁止の変更の場合のみ呼び出す）
        let childIds = new Array<number>();
        this.GetChildrenID(childIds);
        if (!childIds.includes(targetId)) {
            return false;
        }

        let directlytChildIds = new Array<number>();
        this.GetDirectlytChildrenID(directlytChildIds);
        let result = false;
        if (directlytChildIds.includes(targetId)) {

            let res = RestrictionData.STATE_DISAPPROVAL;
            for (let i = 0; i < this.arChildren.length; i++) {
                if (this.arChildren[i].restrictionBit == targetId || itemArray.includes(this.arChildren[i].restrictionBit)) {
                    continue; // 今回禁止に切り替えられた項目は禁止判定（現段階では状態が切り替わっていないため）
                }
                res = this.arChildren[i].checkState;
                if (res === RestrictionData.STATE_APPROVAL) {
                    break;
                }
            }

            if (res === RestrictionData.STATE_DISAPPROVAL) {
                // 配下が全OFFのため要逆依存
                result = true;
            }
        }
        else {
            for (let i = 0; i < this.arChildren.length; i++) {
                if (this.arChildren[i].IsReserveDepCase(targetId, itemArray)) {
                    result = true;
                }
            }
        }

        return result;
    }

    // 対象の親項目IDを取得
    public GetDirectlytParentID(targetId: number, parentId: Array<number>) {
        let directlytChildIds = new Array<number>();
        this.GetDirectlytChildrenID(directlytChildIds);
        if (directlytChildIds.includes(targetId)) {
            // 対象項目のみ実行
            parentId.push(this.restrictionBit);
            return;
        }

        for (let i = 0; i < this.arChildren.length; i++) {
            this.arChildren[i].GetDirectlytParentID(targetId, parentId);
        }
    }

    // 対象の直下項目IDを取得
    public GetDirectlytChildrenID(childrenId: Array<number>) {
        // 対象項目のみ実行
        for (let i = 0; i < this.arChildren.length; i++) {
            childrenId.push(this.arChildren[i].restrictionBit);
        }
    }
}